module.exports = __webpack_public_path__ + "assets/3d-printed-home-1eed33abb583df5701881fee7182accd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/3d-printed-home.jpg
// module id = 501
// module chunks = 1